import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LastPlayedGamesModule } from "../last-played-games/last-played-games.module";
import { AskCustomerRotateModule } from "../ask-customer-rotate/ask-customer-rotate.module";

import { GameComponent } from "./game.component";



@NgModule({
  declarations: [
    GameComponent
  ],
  imports: [
    AskCustomerRotateModule,
    CommonModule,
    LastPlayedGamesModule
  ],
  exports:[
    GameComponent
  ]
})
export class GameModule { }
